export default __webpack_public_path__ + "static/media/form-icon.87e7ea44.svg";